export interface PrescriptionChargeAmount {
  sourceType: number
  chargeType: number
  itemName: string
  payStatus: boolean
  totalPrice: number
  payAmount: number
}

// get-charge-detail: payAmount 为实付减退款；未收费项目使用 totalPrice。
export const summarizePrescriptionCharges = (charges: PrescriptionChargeAmount[]) => {
  const rows = new Map<string, number>()
  const labels: Record<number, string> = {
    1: '挂号费', 2: '快递费', 3: '加工费', 4: '处方药品',
  }
  for (const item of charges) {
    // 配置约定：处方药品、挂号、加工、快递、附加费，不含零售和治疗理疗。
    if (item.sourceType !== 1 || ![1, 2, 3, 4, 5].includes(item.chargeType)) continue
    const rawAmount = item.payStatus ? item.payAmount : item.totalPrice
    if (rawAmount === null || rawAmount === undefined || !Number.isFinite(Number(rawAmount))) {
      throw new Error('收费明细金额缺失，无法打印门诊总金额')
    }
    const label = item.chargeType === 5 ? item.itemName : labels[item.chargeType]
    const cents = Math.round(Number(rawAmount) * 100)
    rows.set(label, (rows.get(label) || 0) + cents)
  }
  return {
    total: [...rows.values()].reduce((sum, cents) => sum + cents, 0) / 100,
    rows: [...rows].map(([label, cents]) => ({ label, amount: cents / 100 })),
  }
}
